import React from 'react';
import { Box, Typography, Grid, Card, CardMedia, Avatar } from '@mui/material';
import testimonialImage from '../../../assets/images/testimonial.JPG';
import testimonialAlexTarcea from '../../../assets/videos/testimonials/testimonial-alexandru-tarcea.mp4';
import testimonialThumbnailAlexTarcea from  '../../../assets/images/thumbnails/testimonials/thumbnail-alexandru-tarcea.png';
import testimonialAndreeaBirsan from '../../../assets/videos/testimonials/testimonial-andreea-birsan.mp4';
import testimonialThumbnailAndreeaBirsan from '../../../assets/images/thumbnails/testimonials/thumbnail-andreea-birsan.png';

const testimonialImages = [
    testimonialImage,
    testimonialImage,
    testimonialImage,
    testimonialImage,
    testimonialImage,
    testimonialImage,
];


const successStories = [
  {
    name: 'Oana Manase, contabil & investitor',
    title: 'Lorem ipsum viverra',
    description: 'Sunt contabil, dar asta nu m-a ajutat deloc când a venit vorba de investiții. Am făcut greșeli, am mers pe noroc și am tras niște țepe bune până am înțeles cât de importantă e educația financiară reală și, mai ales, comunitatea potrivită. De când am intrat în Academillion ca membru fondator, totul s-a schimbat. Am primit sprijin direct de la Lavinia și Ciprian, care m-au ghidat pas cu pas în achiziția primelor mele două apartamente pentru investiții. Nu mă mai simt singură și știu că deciziile mele sunt validate și calculate. Asta face toată diferența.',
    avatar: testimonialThumbnailAlexTarcea,
    video: testimonialAlexTarcea,
  },
  {
    name: 'Bogdan Moldovicean, inginer-constructor & investitor',
    title: 'Lorem ipsum viverra',
    description: 'Sunt inginer constructor, lucrez în Germania de peste 9 ani, și deși am început să investesc din facultate, nu reușeam să-mi dau seama cum să-mi construiesc un plan clar. Am învățat multe din programe de dezvoltare personală, dar îmi lipsea fix componenta de investiții. Asta am găsit în Academillion – o comunitate reală, unde am primit sprijin, mentorat și, cel mai important, am dobândit claritate. Am redeschis proiecte pe care le abandonasem, am găsit oportunități noi și mi-am schimbat complet perspectiva. Aici nu găsești doar informații, ci o mentalitate de reușită care te inspiră cu fiecare interacțiune.',
    avatar: testimonialThumbnailAndreeaBirsan,
    video: testimonialAndreeaBirsan,
  },
];

const TestimonialsSection = () => {
  return (
    <Box 
        sx={{ 
            //background: "#002077",
            background: "linear-gradient(0deg,rgba(0, 32, 119, 1) 0%, rgba(32, 222, 250, 1) 67%)",
            textAlign: 'center',
            position: 'relative',
            py: { xs: 2, xxl: 6}, 
            px: 1
        }}
    >
        <Box
            sx={{
                width: { xs: "100%", xxl: "70%" },
                margin: "0 auto"
            }}
        >
            <Typography
                variant="h2"
                sx={{ 
                    fontWeight: 'bold',
                    lineHeight: 1.5,
                    fontSize: { xs: "20px", xxl: "36px" },
                    color: '#002077',
                    paddingBottom: { xs: 2, xxl: 4 },
                }}
            >
                Ce spun membrii noștri
            </Typography>

            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                    gap: { xs: 2, xxl: 8 },
                    mb: { xs: 4, xxl: 8 },
                }}
            >
                {testimonialImages.map((img, idx) => (
                    <Box
                        key={idx}
                        sx={{
                            width: { xs: '80%', xxl: '30%' },
                            borderRadius: 3,
                            boxShadow: 10,
                            overflow: 'hidden',
                            backgroundColor: '#fff',
                        }}
                    >
                        <CardMedia
                            component="img"
                            image={img}
                            alt={`Testimonial ${idx + 1}`}
                            sx={{ 
                                width: { xs: "70%", xxl: "100%" }, 
                                margin: 0, 
                                display: 'block' 
                            }}
                        />
                    </Box>
                ))}
            </Box>


            <Typography
                variant="h2"
                sx={{ 
                    fontWeight: 'bold',
                    lineHeight: 1.5,
                    fontSize: { xs: "20px", xxl: "36px" },
                    color: '#fff',
                    paddingBottom: { xs: 2, xxl: 4 }, 
                }}
            >
                Povești de succes
            </Typography>

            {/* Video Testimoniale */}
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', xxl: 'row' },
                    gap: { xs: 2, xxl: 4 },
                    width: { xs: '80%', xxl: '100%' },
                    margin: { xs: '0 auto', xxl: '0 auto' }
                }}
            >
                {successStories.map((story, idx) => (
                    <Box
                        key={idx}
                        sx={{
                            backgroundColor: '#fff',
                            borderRadius: '20px',
                            boxShadow: 10,
                            display: 'flex',
                            flexDirection: { xs: 'column', xxl: 'row' },
                            p: 3,
                            gap: 2,
                            width: '100%',
                            alignItems: 'center',
                        }}
                    >
                        <Box
                            sx={{
                                width: { xs: '250px', xxl: '200px' },
                                height: { xs: '400px', xxl: '350px' },
                                borderRadius: 2,
                                overflow: 'hidden',
                                flexShrink: 0,
                                backgroundColor: '#000',
                                alignSelf: { xs: 'center', xxl: 'flex-start' },
                            }}
                        >
                            <video
                                controls
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                }}
                            >
                            <source src={story.video} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        </Box>

                        {/* Text section */}
                        <Box>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: { xs: 2, xxl: 4 },
                                    flexGrow: 1,
                                    mb: 1,
                                }}
                            >
                                <Typography variant="subtitle1" fontWeight="bold" color="#002c6e" 
                                    sx={{
                                        fontSize: { xs: "14px", xxl: "16px" },
                                    }}
                                >
                                    {story.name}
                                </Typography>
                                {/* <Typography
                                    variant="caption"
                                    fontWeight="bold"
                                    color="text.secondary"
                                    sx={{ mb: 1, fontSize: { xs: "12px", xxl: "16px" } }}
                                    >
                                    {story.title}
                                </Typography> */}
                                <Avatar
                                    src={story.avatar}
                                    sx={{
                                        width: 60,
                                        height: 60,
                                        border: "2px solid #002077"
                                    }}
                                />
                            </Box>
                            
                            <Typography variant="body2" color="text.primary"
                                sx={{ fontSize: { xs: "12px", xxl: "14px" } }}
                            >
                            {story.description}
                            </Typography>
                        </Box>
                    </Box>
                ))}
            </Box>



        </Box>
    </Box>
  );
};

export default TestimonialsSection;